import { type TypedDocumentNode, gql } from '@apollo/client';
import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Tooltip } from '@sorare/core/src/atoms/tooltip/Tooltip';
import { LabelS } from '@sorare/core/src/atoms/typography';
import { playerUnavailability } from '@sorare/core/src/lib/glossary';

import type { BenchExtraInjuryTooltip_injury } from './__generated__/index.graphql.ts';

type Props = { children: ReactNode; injury: BenchExtraInjuryTooltip_injury };
export const BenchExtraInjuryTooltip = ({ children, injury }: Props) => {
  return (
    <Tooltip
      title={
        <Vertical gap={0.5}>
          <Horizontal gap={0.5}>
            <LabelS>{injury.kind}</LabelS>
            {!!injury.startDate && (
              <LabelS color="var(--c-nd-600)">
                <FormattedMessage
                  {...playerUnavailability.unavailableSince}
                  values={{ unavailableSince: injury.startDate }}
                />
              </LabelS>
            )}
          </Horizontal>
          <LabelS color="var(--c-nd-600)">
            {injury.expectedEndDate ? (
              <FormattedMessage
                {...playerUnavailability.expectedReturnDate}
                values={{ date: injury.expectedEndDate }}
              />
            ) : (
              <FormattedMessage {...playerUnavailability.unknownReturnDate} />
            )}
          </LabelS>
        </Vertical>
      }
    >
      {children}
    </Tooltip>
  );
};

BenchExtraInjuryTooltip.fragments = {
  injury: gql`
    fragment BenchExtraInjuryTooltip_injury on Injury {
      id
      startDate
      expectedEndDate
      kind
    }
  ` as TypedDocumentNode<BenchExtraInjuryTooltip_injury>,
};
